import { inject, Injectable, signal } from '@angular/core';
import { EngagementFollowUpDetail, EngagementFollowUpForm } from '@interfaces';
import { FuncService } from '../../../../services';

@Injectable({
	providedIn: 'root'
})
export class FollowUpDialogService {

	private func = inject(FuncService);
	public readonly followUpDetails = signal<EngagementFollowUpDetail | undefined>(undefined)

	public async addFollowUp(payload: EngagementFollowUpForm, engagementId?: number) {
		const result = await this.func.engagement.followUp.add({
			followUpPayload: payload,
			engagementId: engagementId
		});
		return result;
	}

	public async updateFollowUp(followUpId: number, followUpPayload: EngagementFollowUpForm) {
		const result = await this.func.engagement.followUp.update({ followUpId, followUpPayload });
		return result;
	}

	public async getFollowUpById(followUpId: number) {
		const result = await this.func.engagement.followUp.get({ followUpId });
		this.followUpDetails.set(result);
		return result;
	}
}